// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bw-modalHeader{padding-bottom:.6rem}.bw-modalRoot{overflow:hidden}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalHeader": "bw-modalHeader",
	"modalRoot": "bw-modalRoot"
};
module.exports = ___CSS_LOADER_EXPORT___;
